import ImaiosForm from '@assets/js/imaios-form/imaios-form.model';
import LoginManagementService from '@assets/js/imaios-connection-management/login-management-service';
import { get, onPageLoaded, pubsub, store } from '@assets/js/imaios-global/imaios-global';
import {
  changeDefinitionFromHash,
  getHashFromSelectedLanguage,
  selectLanguageFromHash
} from '@templates/components/structures/definition/languageSwitcher/languageSwitcher';

export function updateStructureDefinitionData() {
  updateWindowFrontpage();
  structureEditionJs();
}

onPageLoaded(() => {
  updateStructureDefinitionData();
});

export function structureEditionJs() {
  window.ImaiosForm = ImaiosForm;
  window.loginManagementService = LoginManagementService;
  window.getFromImaiosStore = get;
  window.languageSwitcher = {
    changeDefinitionFromHash,
    getHashFromSelectedLanguage,
    selectLanguageFromHash
  };
}

export function updateWindowFrontpage() {
  const mainContent = document.getElementById('anatomical-frontpage-content').dataset;

  store('application', mainContent.applicationUrl);
  store('currentHash', mainContent.currentHash);
  store('valid-ta', mainContent.validTa);
  pubsub.publish('list-ta-updated');
}
